import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
export const authenticationFactorList = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.AuthenticationFactorList), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const authenticationFactorSelf = async (authenticationFactorId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.AuthenticationFactorSelf, {
        authenticationFactorId,
    }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const authenticationFactorCreate = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.AuthenticationFactorCreate), {
        credentials: "include",
        headers,
        json: {
            authentication_factors: body,
        },
    }).json();
};
export const authenticationFactorTrigger = async (authenticationFactorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.AuthenticationFactorTrigger, {
        authenticationFactorId,
    }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const authenticationFactorVerify = async (authenticationFactorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.AuthenticationFactorVerify, {
        authenticationFactorId,
    }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const authenticationFactorDisable = async (authenticationFactorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.AuthenticationFactorDisable, {
        authenticationFactorId,
    }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const authenticationFactorDisableOrgUser = async (authenticationFactorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.AuthenticationFactorDisableOrgUser, {
        authenticationFactorId,
    }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
